module.exports = __webpack_public_path__ + "static/img/content-banner.12152c0b.jpg";